import _ from 'lodash';

/**
 * 替换全部空格
 * @param {*} str
 */
export function replaceAllSpace(str) {
  if (!_.isString(str)) {
    throw new Error('参数必须是个string');
  }
  return str.replace(/\s/g, '');
}
export default function trim(target, trimFunc = _.trim) {
  if (_.isString(target)) {
    return trimFunc(target);
  }
  if (_.isArray(target)) {
    return _.map(target, trimFunc);
  }
  if (_.isPlainObject(target)) {
    const newObj = Object.assign({}, target);

    Object.keys(newObj).forEach((key) => {
      if (_.isString(newObj[key])) {
        newObj[key] = trimFunc(newObj[key]);
      }
    });

    return newObj;
  }
}

export function trimAllSpace(str) {
  return trim(str, replaceAllSpace);
}
